import {AxiosResponse} from 'axios';
import {gateway} from '../config/api';
import {affiliateCodeProps} from '../types/types';

interface getAffiliateCodeResponseType extends AxiosResponse {
  data: affiliateCodeProps;
}

async function getAffiliateCode(): Promise<string> {
  const res: getAffiliateCodeResponseType = await gateway().get(`/affiliates`);

  const {data} = res;

  if (res.status === 200) {
    return data.code;
  }
  return Promise.reject('Sorry, something went wrong');
}

export default {
  getAffiliateCode,
};
